import IAuction from "../auction/IAuction";
import Constants from "./Constants";

export function sortAuctionByDateDescending(
    auction1: IAuction,
    auction2: IAuction
) {
    if (auction1.auctionDate > auction2.auctionDate) return -1;
    if (auction1.auctionDate < auction2.auctionDate) return 1;
    return 0;
}

export function sortAuctionByDateAscendingUnscheduledLast(
    auction1: IAuction,
    auction2: IAuction
) {
    const isUnscheduled1 = auction1.auctionDate === Constants.UnscheduledTime;
    const isUnscheduled2 = auction2.auctionDate === Constants.UnscheduledTime;
    if (isUnscheduled1 !== isUnscheduled2) return isUnscheduled1 ? 1 : -1;
    if (auction1.auctionDate < auction2.auctionDate) return -1;
    if (auction1.auctionDate > auction2.auctionDate) return 1;
    return 0;
}
